import React from "react";
import { useNavigate } from "react-router-dom";
import HotlineStatusBadge from "@/pages/hotline/HotlineStatusBadge";
import { api } from "@/lib/api";

export default function PatientHotlineTab({ patientId }) {
  const [data, setData] = React.useState({ sessions: [], escalations: [], follow_ups: [] });
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();
  React.useEffect(() => {
    api.get(`/hotline/patients/${patientId}/sessions`).then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [patientId]);
  return (
    <div className="space-y-4" data-testid="patient-hotline-tab">
      <div className="hah-card p-5">
        <h3 className="text-base font-semibold text-[#1F2937] mb-3">Hotline sessions</h3>
        {loading ? <div className="text-sm text-[#6B7280]">Loading…</div> : data.sessions.length === 0 ? (
          <div className="text-sm text-[#6B7280]">No hotline sessions for this patient.</div>
        ) : (
          <div className="space-y-2">
            {data.sessions.map((s) => (
              <button key={s.id} onClick={() => navigate(`/hotline/sessions/${s.id}`)} className="w-full text-left p-3 border border-[#E5E7EB] rounded-lg hover:bg-[#EAF8FA]/40 flex items-center gap-3">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-mono text-xs text-[#0B7E8C] font-medium">{s.record_id}</span>
                    <span className="text-xs text-[#6B7280]">{new Date(s.created_at).toLocaleString()}</span>
                  </div>
                  <div className="text-sm text-[#1F2937] truncate">{s.chief_complaint?.description || "—"}</div>
                </div>
                <HotlineStatusBadge status={s.status} />
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="hah-card p-5">
          <h4 className="font-semibold text-[#1F2937] mb-2">Escalations</h4>
          {data.escalations.length === 0 ? <div className="text-sm text-[#6B7280]">None.</div> : (
            <ul className="space-y-2 text-sm">
              {data.escalations.map((e) => (
                <li key={e.id} className="border-b border-[#E5E7EB] pb-1.5">
                  <div className="font-medium text-[#1F2937] capitalize">{e.type.replace(/_/g, " ")}</div>
                  <div className="text-xs text-[#6B7280]">{e.reason} · <span className="capitalize">{e.status.replace(/_/g, " ")}</span></div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="hah-card p-5">
          <h4 className="font-semibold text-[#1F2937] mb-2">Follow-ups</h4>
          {data.follow_ups.length === 0 ? <div className="text-sm text-[#6B7280]">None.</div> : (
            <ul className="space-y-2 text-sm">
              {data.follow_ups.map((f) => (
                <li key={f.id} className="border-b border-[#E5E7EB] pb-1.5">
                  <div className="font-medium text-[#1F2937]">Due {f.due_date}</div>
                  <div className="text-xs text-[#6B7280]">{f.reason} · <span className="capitalize">{f.status.replace(/_/g, " ")}</span></div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
